import { render, staticRenderFns } from "./HealthReviewedLine.vue?vue&type=template&id=038cb5f6"
import script from "./HealthReviewedLine.vue?vue&type=script&lang=js"
export * from "./HealthReviewedLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports